import { Flex } from '@aloft/toolkit-sui';

import { ReactElement } from 'react';

import { Tkv2ReferenceBarPropertyProps } from './Tkv2ReferenceBarProperty.tsx';

type Tkv2ReferenceBarSectionProps = {
  property: ReactElement<Tkv2ReferenceBarPropertyProps>;
};

export const Tkv2ReferenceBarSection = ({ property }: Tkv2ReferenceBarSectionProps) => {
  return (
    <>
      <Flex
        height=".125rem"
        width="90%"
        margin="0 auto"
        flexShrink={0}
        backgroundColor="strokeActive"
      />
      {property}
    </>
  );
};
